module.exports = __webpack_public_path__ + "img/prize-02.df5e7e0e.png";